import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpiderChartComponent } from './spiderChart.component';
import { NgChartsModule } from 'ng2-charts';

@NgModule({
  imports: [CommonModule, NgChartsModule],
  declarations: [SpiderChartComponent],
  exports: [SpiderChartComponent],
})
export class SpiderChartModule {}
